import Vue from 'vue'
import VueI18n from 'vue-i18n'

import localeData from 'buildLocale'
import localeFallback from 'fallbackLocale'

const messages = {
  'default': localeData,
  'fallback': localeFallback
}

Vue.use(VueI18n)

var i18n = new VueI18n({
  locale: 'default',
  fallbackLocale: 'fallback',
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/locale/index.js